import React, { useEffect, useState } from 'react';
import ActionButton from './ActionButton';
import { useCart } from '../context/CartContext';

const ComboBanner = ({
  combos,
  sectionClassName = '',
  sectionId = 'combos',
  ctaLabel,
  ctaLink,
}) => {
  const [quantities, setQuantities] = useState({});
  const [confirmation, setConfirmation] = useState(null);
  const { addItem } = useCart();

  const getQuantity = (comboId) => quantities[comboId] || 1;

  const setQuantity = (comboId, qty) => {
    setQuantities((prev) => ({ ...prev, [comboId]: Math.max(1, qty) }));
  };

  const handleAddToCart = (combo) => {
    const qty = getQuantity(combo.id);
    addItem(
      { id: combo.id, name: combo.name, price: combo.price, type: 'combo', image: combo.image || null },
      qty
    );
    setConfirmation(`${qty}× ${combo.name} added to cart!`);
    setQuantity(combo.id, 1);
  };

  useEffect(() => {
    if (!confirmation) return undefined;
    const timeout = setTimeout(() => setConfirmation(null), 2800);
    return () => clearTimeout(timeout);
  }, [confirmation]);

  return (
  <section className={`combo-section ${sectionClassName}`.trim()} id={sectionId}>
    <div className="combo-intro">
      <p className="eyebrow">Combo packages</p>
      <h2>Group-ready meals built for events</h2>
      <p>
        Pick a ready menu or request a bespoke combo for your event. Each combo pairs
        signature mains with sides, protein, and service-ready plating.
      </p>
    </div>
    {ctaLabel && ctaLink && (
      <div className="combo-preview-header">
        <ActionButton size="xs" variant="outline" to={ctaLink}>
          {ctaLabel}
        </ActionButton>
      </div>
    )}
    <div className="combo-grid">
      {combos.map((combo) => (
        <article key={combo.id} className="combo-card">
          <div className="combo-image">
            <img src={combo.image} alt={combo.name} loading="lazy" />
          </div>
          <div className="combo-content">
            <div className="combo-heading">
              <h3>{combo.name}</h3>
              <span className="combo-price">₦{combo.price.toLocaleString()}</span>
            </div>
            <p>{combo.description}</p>
            <p className="combo-savings">{combo.savingsText}</p>
            <ul>
              {combo.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <div className="combo-card-quantity">
              <label htmlFor={`qty-${combo.id}`}>Qty:</label>
              <div className="quantity-controls">
                <button
                  onClick={() => setQuantity(combo.id, getQuantity(combo.id) - 1)}
                  aria-label="Decrease quantity"
                >
                  −
                </button>
                <input
                  id={`qty-${combo.id}`}
                  type="number"
                  min="1"
                  value={getQuantity(combo.id)}
                  onChange={(e) => setQuantity(combo.id, parseInt(e.target.value) || 1)}
                />
                <button
                  onClick={() => setQuantity(combo.id, getQuantity(combo.id) + 1)}
                  aria-label="Increase quantity"
                >
                  +
                </button>
              </div>
            </div>
            <ActionButton 
              variant="primary" 
              size="sm"
              onClick={() => handleAddToCart(combo)}
              className="combo-add-btn"
            >
              Add to order
            </ActionButton>
            {confirmation && confirmation.includes(combo.name) && (
              <p className="combo-added-feedback">{confirmation}</p>
            )}
          </div>
        </article>
      ))}
    </div>
  </section>
  );
};

export default ComboBanner;
